import { OperatingHours } from '@edwt/cms/schema/fields/operating-hours';
import { useState, useEffect } from 'react';

export function getOpenState(currentDate: Date, operatingHours: OperatingHours, open247: boolean, overrideOpenStatus: string | false) {

    if (overrideOpenStatus !== false) return {
        isOpen: overrideOpenStatus === 'open' ? true : false,
        closingInMinutes: 0,
    };

    if (open247 === true) return {
        isOpen: true,
        closingInMinutes: 0,
    }

    const currentDay = currentDate.getDay();

    // Get current time without a date (Unix Epoch Time)
    const currentTime = new Date(
        1970,
        0,
        1,
        currentDate.getHours(),
        currentDate.getMinutes(),
        currentDate.getSeconds()
    );

    const currentDayOperatingHours =
        operatingHours.days[currentDay];

    const currentDayOpenTime = new Date(currentDayOperatingHours.open);
    const currentDayCloseTime = new Date(currentDayOperatingHours.close);

    const isOpen =
        currentTime.getTime() >= currentDayOpenTime.getTime() &&
        currentTime.getTime() <= currentDayCloseTime.getTime();

    // const isOpen = (currentDate.getSeconds() + currentDayCloseTime.getMinutes() + currentDayOpenTime.getMinutes()) % 2 == 0;

    const closingInMinutes = isOpen
        ? (currentDayCloseTime.getTime() - currentTime.getTime()) / 60000
        : 0;


    return {
        isOpen: isOpen,
        closingInMinutes: closingInMinutes,
    };
}

export function useOperatingHours(operatingHours: OperatingHours, open247: boolean, overrideOpenStatus: string | false) {

    const [currentDate, setCurrentDate] = useState<Date>(new Date());

    const { isOpen: initialIsOpen, closingInMinutes: initialClosingInMinutes } = getOpenState(currentDate, operatingHours, open247, overrideOpenStatus);

    const [isOpen, setIsOpen] = useState<boolean>(initialIsOpen);
    const [closingInMinutes, setClosingInMinutes] = useState<number>(initialClosingInMinutes);


    useEffect(() => {

        const interval = setInterval(() => {
            setCurrentDate(new Date());

            const { isOpen: newIsOpen, closingInMinutes: newClosingInMinutes } = getOpenState(currentDate, operatingHours, open247, overrideOpenStatus);

            setIsOpen(newIsOpen);
            setClosingInMinutes(newClosingInMinutes);


            // console.log(currentDate.getTime());
        }, 10 * 1000);

        return () => clearInterval(interval);
    }, [currentDate, open247, operatingHours, overrideOpenStatus]);

    return {
        isOpen,
        closingInMinutes,
    }
}